const normalize = (value) => String(value || '').trim().toLowerCase();

export const isCollegeStudentExperience = (user) => {
  const mode = normalize(user?.studentExperience?.mode);
  if (mode) return mode === 'college';

  const access = user?.collegeAccess || {};
  return normalize(access.registrationSource) === 'college_portal'
    && normalize(access.status) === 'authorized';
};

export const studentHomePath = (user) => (
  isCollegeStudentExperience(user) ? '/lms?tab=dashboard' : '/dashboard'
);
